module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_1_PL-145e603f571502cd08aeaf50804df184.svg";